module.exports = __webpack_public_path__ + "static/02-thumb-4448585ec450e20ea29150bac7188e1a.jpg";